import React, { useEffect, useState } from 'react';
import { Icon, Switch, DatePicker, TimePicker, Row, Col, Select } from 'antd';
import moment from 'moment';
import * as S from '../styles';
import { useBatchJob } from '../../../../../context/BatchJobContext';
import { useTranslation } from 'react-i18next';
import { BATCH_JOBS_DASHBOARD as trans } from '../translationValues';
import { getUser } from '../../../../../utils/services/userAPI';
import { batchSchedule } from '../../../../../utils/services/statusMonitoringAPI';

const NAMESPACE = ['BATCH_JOBS_DASHBOARD'];

const Step5Scheduling = () => {
  const {
    scheduleEnabled,
    setScheduleEnabled,
    scheduleDate,
    setScheduleDate,
    scheduleTime,
    setScheduleTime,
    approvalEnabled,
    setApprovalEnabled,
    approvalType,
    setApprovalType,
    approvalLevel,
    setApprovalLevel,
    selectedApprover,
    setSelectedApprover,
    batchId,
    approvers,
  } = useBatchJob();

  console.log('aa44', approvers);


  const [users, setUsers] = useState();

  const getUserList = async () => {
    try {
      const response = await getUser();
      const targetRoles = [10, 11, 12, 13];
      const filteredUsers = response?.data?.filter(user =>
        user.roles?.some(role => targetRoles.includes(role))
      );
      setUsers(filteredUsers);
    }
    catch {
      //hanldelater
    }
  }

  useEffect(() => {
    getUserList();
  }, [])

  const { t } = useTranslation(NAMESPACE);

  const handleSelectUser = val => {
    setSelectedApprover(val);
    setApprovalType('USER');
  };

  const handleChange = (date) => {
    const formattedDate = new Date(date).toISOString().split('T')[0];
    setScheduleDate(formattedDate);
    console.log(formattedDate);
    // Output: 2026-02-23
  }

  return (
    <S.StepContent>
      <S.FormContainer>
        <S.StepHeader>
          <S.StepHeaderTitle>
            {t(trans.SCHEDULE_CAMPAIGN_TITLE.key, trans.SCHEDULE_CAMPAIGN_TITLE.value)}
          </S.StepHeaderTitle>
          <S.StepSubtitle>
            {t(trans.SCHEDULE_CAMPAIGN_SUBTITLE.key, trans.SCHEDULE_CAMPAIGN_SUBTITLE.value)}
          </S.StepSubtitle>
        </S.StepHeader>
        <S.ActionCard>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <S.IconBox color="#927BF8">
              <Icon type="calendar" style={{ fontSize: '20px' }} />
            </S.IconBox>
            <div>
              <div style={{ fontWeight: '700', fontSize: '15px' }}>
                {t(trans.ENABLE_SCHEDULING.key, trans.ENABLE_SCHEDULING.value)}
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>
                {t(trans.SCHEDULE_DESC.key, trans.SCHEDULE_DESC.value)}
              </div>
            </div>
          </div>
          <Switch className="switch" checked={scheduleEnabled} onChange={setScheduleEnabled} />
        </S.ActionCard>

        {!scheduleEnabled && (
          <S.ImmediateCard>
            <S.BoltIcon>
              <Icon type="thunderbolt"/>
            </S.BoltIcon>
            <div style={{ fontWeight: '800', fontSize: '18px', color: '#1f2937' }}>
              {t(trans.SEND_IMMEDIATELY.key, trans.SEND_IMMEDIATELY.value)}
            </div>
            <div style={{ fontSize: '14px', color: '#6b7280' }}>
              {t(trans.SEND_IMMEDIATELY_DESC.key, trans.SEND_IMMEDIATELY_DESC.value)}
            </div>
          </S.ImmediateCard>
        )}

        {scheduleEnabled && (
          <S.ConfigSection style={{ marginBottom: '24px' }}>
            <div
              style={{
                fontWeight: '600',
                fontSize: '0.875rem',
                color: '#1f2937;',
                marginBottom: '1rem',
              }}
            >
              {t(trans.DATE_TIME_TO_SCHEDULE.key, trans.DATE_TIME_TO_SCHEDULE.value)}
            </div>
            <Row gutter={24}>
              <Col span={12}>
                <S.Label>
                  {t(trans.SELECT_DATE.key, trans.SELECT_DATE.value)} <S.Required>*</S.Required>
                </S.Label>
                <S.StyledDatePicker
                  style={{ width: '100%' }}
                  size="large"
                  value={scheduleDate ? moment(scheduleDate) : null}
                  onChange={(date) => { handleChange(date) }}
                  getCalendarContainer={trigger => trigger.parentNode}
                  disabledDate={current => current && current < moment().startOf('day')}
                />
              </Col>
              <Col span={12}>
                <S.Label>
                  {t(trans.SELECT_TIME.key, trans.SELECT_TIME.value)} <S.Required>*</S.Required>
                </S.Label>
                <S.StyledTimePicker
                  style={{ width: '100%' }}
                  size="large"
                  format="HH:mm"
                  value={scheduleTime ? moment(scheduleTime, 'HH:mm') : null}
                  onChange={(t, ts) => setScheduleTime(ts)}
                  getPopupContainer={trigger => trigger.parentNode}
                  disabledHours={() => {
                    const now = moment();
                    const selectedDate = scheduleDate ? moment(scheduleDate) : null;
                    if (selectedDate && selectedDate.isSame(now, 'day')) {
                      return Array.from({ length: now.hour() }, (_, i) => i);
                    }
                    return [];
                  }}
                  disabledMinutes={selectedHour => {
                    const now = moment();
                    const selectedDate = scheduleDate ? moment(scheduleDate) : null;
                    if (selectedDate && selectedDate.isSame(now, 'day') && selectedHour === now.hour()) {
                      return Array.from({ length: now.minute() + 1 }, (_, i) => i);
                    }
                    return [];
                  }}
                />
              </Col>
            </Row>
          </S.ConfigSection>
        )}

        <S.ActionCard>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <S.IconBox color="#927BF8">
              <Icon type="check-circle" style={{ fontSize: '20px' }} />
            </S.IconBox>
            <div>
              <div style={{ fontWeight: '700', fontSize: '15px' }}>
                {t(trans.ENABLE_APPROVAL.key, trans.ENABLE_APPROVAL.value)}
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>
                {t(trans.APPROVAL_DESC.key, trans.APPROVAL_DESC.value)}
              </div>
            </div>
          </div>
          <Switch checked={approvalEnabled} onChange={setApprovalEnabled} />
        </S.ActionCard>

        {approvalEnabled && (
          <S.ConfigSection>
            {/* <S.TabGroup>
              <S.Tab active={approvalType === 'level'} onClick={() => setApprovalType('level')}>
                <Icon type="team" /> {t(trans.APPROVAL_LEVEL.key, trans.APPROVAL_LEVEL.value)}
              </S.Tab>
              <S.Tab active={approvalType === 'user'} onClick={() => setApprovalType('user')}>
                <Icon type="user" /> {t(trans.SPECIFIC_USER.key, trans.SPECIFIC_USER.value)}
              </S.Tab>
            </S.TabGroup> */}

            {/* <div>
                <S.Label style={{ fontSize: '15px' }}>
                  {t(trans.SELECT_APPROVAL_LEVEL.key, trans.SELECT_APPROVAL_LEVEL.value)}{' '}
                  <S.Required>*</S.Required>
                </S.Label>
                <S.LevelGrid>
                  {['1', '2', '3', '4'].map(lvl => (
                    <S.LevelButton
                      key={lvl}
                      selected={approvalLevel === lvl}
                      onClick={() => setApprovalLevel(lvl)}
                    >
                      {t(trans.LEVEL_LABEL.key, {
                        level: lvl,
                        defaultValue: trans.LEVEL_LABEL.value,
                      })}
                    </S.LevelButton>
                  ))}
                </S.LevelGrid>
                <div style={{ fontSize: '13px', color: '#6b7280', fontWeight: '500' }}>
                  {t(trans.APPROVAL_LEVEL_REQUIRED_DESC.key, {
                    level: approvalLevel,
                    defaultValue: trans.APPROVAL_LEVEL_REQUIRED_DESC.value,
                  })}
                </div>
              </div> */}

            <div>
              <S.Label style={{ fontSize: '15px' }}>
                {t(trans.SELECT_APPROVER.key, trans.SELECT_APPROVER.value)}{' '}
                {/* <S.Required>*</S.Required> */}
              </S.Label>
              <Select
                showSearch
                size="large"
                placeholder={t(
                  trans.SEARCH_USER_PLACEHOLDER.key,
                  trans.SEARCH_USER_PLACEHOLDER.value,
                )}
                value={selectedApprover}
                onChange={handleSelectUser}
                style={{ width: '100%' }}
                optionFilterProp="children"
                getPopupContainer={triggerNode => triggerNode.parentNode}
                dropdownStyle={{ zIndex: 10001 }}
                filterOption={(input, option) => {
                  const children = option.props.children;

                  const label = Array.isArray(children) ? children.join('') : children;

                  return String(label)
                    .toLowerCase()
                    .includes(input.toLowerCase());
                }}
              >
                {approvers.map(a => {
                  return (
                    <Select.Option key={a.id} value={a.id}>
                      {a.displayName}
                    </Select.Option>
                  );
                })}
              </Select>
            </div>
          </S.ConfigSection>
        )}
      </S.FormContainer>
    </S.StepContent>
  );
};

export default Step5Scheduling;
